// @ts-check

import { MapView, Mappedin, MappedinNode, getVenue } from "@mappedin/mappedin-js";
import { useEffect, useState } from "react";
import { MapLocationTooltipLogic } from "../Logic/mapLocationTooltipLogic";
import { MapSearchResultsLogic } from "../Logic/mapSearchResultsLogic";
import { MapNormalViewLogic } from "../Logic/mapNormalViewLogic";


/**
 * @typedef {import("../../../actions/LiveMap/liveMapPageTypes").LocationTooltipState} LocationTooltipState
 * 
 */


/**
 * @param {any | undefined} sData
 * @param {MapView | undefined} mapView
 * @param {any | undefined} currentEntrance
 * @param {(mapView: MapView) => void} recolorMap
 */
export default function useHandleServerData(sData, mapView, currentEntrance, recolorMap) {


  useEffect(() => {
    
    if (!mapView) {
      return;
    }
    
    let venue = mapView.venue;
    if (!venue) {
      return;
    }
  
    
    
    MapLocationTooltipLogic.process(sData, venue, mapView, currentEntrance, recolorMap);
    MapSearchResultsLogic.process(sData, venue, mapView, currentEntrance, recolorMap);
    // MapNormalViewLogic.process(sData, venue, mapView, currentEntrance, recolorMap);




  }, [sData, mapView]);


  return [

  ];
}




